/** @jsx jsx */
import React from "react";
import { jsx, Container, Flex, Button, Text } from "theme-ui";
import { keyframes } from "@emotion/react";
import { Link } from "react-scroll";
import Logo from "components/logo";
import LogoDark from "assets/garaaz-logo-dark.png";
import LogoWhite from "assets/garaaz-logo-light.png";
import { DrawerProvider } from "../../contexts/drawer/drawer.provider";
import MobileDrawer from "./mobile-drawer";
import menuItems from "./header.data";
import { getWebAppOrigin } from "../../utils/web-app-url";

export default function Header({ className }) {
  return (
    <DrawerProvider>
      <header sx={styles.header} className={className} id="header">
        <Container sx={styles.container}>
          <Flex sx={styles.logoContainer}>
            <Logo src={className === "sticky" ? LogoDark : LogoWhite} />
            <Text sx={styles.companyName}>SVAN AUTOTECH PRIVATE LIMITED</Text>
          </Flex>

          <Flex as="nav" sx={styles.nav}>
            {menuItems.map(({ path, label }, i) => (
              <Link
                activeClass="active"
                to={path}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
                key={i}
              >
                {label}
              </Link>
            ))}
          </Flex>

          <Flex sx={styles.loginContainer}>
            <a
              href={getWebAppOrigin()}
              title="Workshop Login"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button
                className="donate__btn"
                variant="secondary"
                aria-label="Workshop Login"
                style={{ marginRight: "0px", cursor: "pointer" }}
              >
                Workshop Login
              </Button>
            </a>

            <MobileDrawer />
          </Flex>
        </Container>
      </header>
    </DrawerProvider>
  );
}

const positionAnim = keyframes`
  from {
    position: fixed;
    opacity: 1;
  }
  to {
    position: absolute;
    opacity: 1;
    transition: all 0.4s ease;
  }
`;

const styles = {
  header: {
    color: "white",
    fontWeight: "normal",
    py: 4,
    width: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 1001,
    backgroundColor: "transparent",
    transition: "all 0.5s ease",
    animation: `${positionAnim} 0.4s ease`,
    ".donate__btn": {
      flexShrink: 0,
      mr: [15, 20, null, null, 0],
      ml: ["auto", null, null, null, 0],
      cursor: "pointer",
    },
    "&.sticky": {
      position: "fixed",
      backgroundColor: "background",
      color: "#000000",
      boxShadow: "0 1px 2px rgba(0, 0, 0, 0.06)",
      py: 3,
      "nev > a": {
        color: "text",
      },
      ".donate__btn": {
        borderColor: "primary",
        color: "primary",
        "&:hover": {
          boxShadow: "rgba(31, 62, 118, 0.57) 0px 9px 20px -5px",
          backgroundColor: "primary",
          color: "white",
        },
      },
    },
  },
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  logoContainer: {
    alignItems: "left",
    justifyContent: "center",
    flexDirection: "column",
  },
  companyName: {
    fontSize: [0, 1],
    fontWeight: "500",
    color: "inherit",
    opacity: 0.8,
  },
  nav: {
    mx: "auto",
    display: "none",
    "@media screen and (min-width: 2150px)": {
      display: "block",
    },
    a: {
      fontSize: "16px",
      fontWeight: "400",
      px: 25,
      cursor: "pointer",
      lineHeight: "1.2",
      "&.active": {
        color: "secondary",
      },
    },
  },
  loginContainer: {
    alignItems: "center",
    gap: "10px",
  },
};
